import {
  ENQUEUE_PUBLISH_JOB,
  REMOVE_PUBLISH_JOB,
  UPDATE_PUBLISH_JOB_PROGRESS,
  MARK_BANNER_LIST_STALE,
  CLEAR_BANNER_LIST_STALE,
  MARK_TEMPLATE_LIST_STALE,
  CLEAR_TEMPLATE_LIST_STALE,
  MARK_PAGES_LIST_STALE,
  CLEAR_PAGES_LIST_STALE,
  MARK_CATEGORIES_LIST_STALE,
  CLEAR_CATEGORIES_LIST_STALE,
  MARK_WIDGETS_LIST_STALE,
  CLEAR_WIDGETS_LIST_STALE,
  MARK_SEO_LIST_STALE,
  CLEAR_SEO_LIST_STALE,
  MARK_INFORMATION_POLICY_LIST_STALE,
  CLEAR_INFORMATION_POLICY_LIST_STALE,
  MARK_ADMIN_SETTINGS_STALE,
  CLEAR_ADMIN_SETTINGS_STALE,
  MARK_CONFIG_SETTINGS_STALE,
  CLEAR_CONFIG_SETTINGS_STALE,
  MARK_GALLERY_LIST_STALE,
  CLEAR_GALLERY_LIST_STALE,
  MARK_OFFICIAL_CONTACT_LIST_STALE,
  CLEAR_OFFICIAL_CONTACT_LIST_STALE,
  MARK_ADMINISTRATION_LIST_STALE,
  CLEAR_ADMINISTRATION_LIST_STALE,
  MARK_PARISH_PRIEST_LIST_STALE,
  CLEAR_PARISH_PRIEST_LIST_STALE,
  MARK_LEADERSHIP_HISTORY_LIST_STALE,
  CLEAR_LEADERSHIP_HISTORY_LIST_STALE,
  MARK_HOUSE_LIST_STALE,
  CLEAR_HOUSE_LIST_STALE,
  MARK_HISTORY_LIST_STALE,
  CLEAR_HISTORY_LIST_STALE,
  MARK_HIERARCHY_LIST_STALE,
  CLEAR_HIERARCHY_LIST_STALE,
  MARK_CHURCH_LIST_STALE,
  CLEAR_CHURCH_LIST_STALE,
  MARK_ORGANIZATION_LIST_STALE,
  CLEAR_ORGANIZATION_LIST_STALE,
  MARK_MEMBERS_LIST_STALE,
  CLEAR_MEMBERS_LIST_STALE,
  MARK_CHAPEL_LIST_STALE,
  CLEAR_CHAPEL_LIST_STALE,
  MARK_NEWS_LIST_STALE,
  CLEAR_NEWS_LIST_STALE,
  MARK_FESTIVALS_LIST_STALE,
  CLEAR_FESTIVALS_LIST_STALE,
  MARK_ADVERTISEMENT_LIST_STALE,
  CLEAR_ADVERTISEMENT_LIST_STALE,
  MARK_OCCASION_LIST_STALE,
  CLEAR_OCCASION_LIST_STALE,
  MARK_LIVE_STREAMING_LIST_STALE,
  CLEAR_LIVE_STREAMING_LIST_STALE,
  MARK_INCOME_PDF_LINK_LIST_STALE,
  CLEAR_INCOME_PDF_LINK_LIST_STALE,
  MARK_EVENTS_LIST_STALE,
  CLEAR_EVENTS_LIST_STALE,
  MARK_QUOTES_LIST_STALE,
  CLEAR_QUOTES_LIST_STALE,
  MARK_POSITION_LIST_STALE,
  CLEAR_POSITION_LIST_STALE,
} from '../constants/PendingPublish';

const staleFlagReducer = (state, markType, clearType, action) => {
  switch (action.type) {
    case markType:
      return { ...state, [markType]: true };
    case clearType:
      return { ...state, [clearType]: false };
    default:
      return state;
  }
};

const initState = {
  jobs: [],
  bannerListStale: false,
  templateListStale: false,
  pagesListStale: false,
  categoriesListStale: false,
  widgetsListStale: false,
  seoListStale: false,
  informationPolicyListStale: false,
  adminSettingsStale: false,
  configSettingsStale: false,
  galleryListStale: false,
  officialContactListStale: false,
  administrationListStale: false,
  parishPriestListStale: false,
  leadershipHistoryListStale: false,
  houseListStale: false,
  historyListStale: false,
  hierarchyListStale: false,
  churchListStale: false,
  organizationListStale: false,
  membersListStale: false,
  chapelListStale: false,
  newsListStale: false,
  festivalsListStale: false,
  advertisementListStale: false,
  occasionListStale: false,
  liveStreamingListStale: false,
  incomePdfLinkListStale: false,
  eventsListStale: false,
  quotesListStale: false,
  positionListStale: false,
};

const stalePairs = [
  ['bannerListStale', MARK_BANNER_LIST_STALE, CLEAR_BANNER_LIST_STALE],
  ['templateListStale', MARK_TEMPLATE_LIST_STALE, CLEAR_TEMPLATE_LIST_STALE],
  ['pagesListStale', MARK_PAGES_LIST_STALE, CLEAR_PAGES_LIST_STALE],
  ['categoriesListStale', MARK_CATEGORIES_LIST_STALE, CLEAR_CATEGORIES_LIST_STALE],
  ['widgetsListStale', MARK_WIDGETS_LIST_STALE, CLEAR_WIDGETS_LIST_STALE],
  ['seoListStale', MARK_SEO_LIST_STALE, CLEAR_SEO_LIST_STALE],
  [
    'informationPolicyListStale',
    MARK_INFORMATION_POLICY_LIST_STALE,
    CLEAR_INFORMATION_POLICY_LIST_STALE,
  ],
  ['adminSettingsStale', MARK_ADMIN_SETTINGS_STALE, CLEAR_ADMIN_SETTINGS_STALE],
  ['configSettingsStale', MARK_CONFIG_SETTINGS_STALE, CLEAR_CONFIG_SETTINGS_STALE],
  ['galleryListStale', MARK_GALLERY_LIST_STALE, CLEAR_GALLERY_LIST_STALE],
  [
    'officialContactListStale',
    MARK_OFFICIAL_CONTACT_LIST_STALE,
    CLEAR_OFFICIAL_CONTACT_LIST_STALE,
  ],
  [
    'administrationListStale',
    MARK_ADMINISTRATION_LIST_STALE,
    CLEAR_ADMINISTRATION_LIST_STALE,
  ],
  [
    'parishPriestListStale',
    MARK_PARISH_PRIEST_LIST_STALE,
    CLEAR_PARISH_PRIEST_LIST_STALE,
  ],
  [
    'leadershipHistoryListStale',
    MARK_LEADERSHIP_HISTORY_LIST_STALE,
    CLEAR_LEADERSHIP_HISTORY_LIST_STALE,
  ],
  ['houseListStale', MARK_HOUSE_LIST_STALE, CLEAR_HOUSE_LIST_STALE],
  ['historyListStale', MARK_HISTORY_LIST_STALE, CLEAR_HISTORY_LIST_STALE],
  ['hierarchyListStale', MARK_HIERARCHY_LIST_STALE, CLEAR_HIERARCHY_LIST_STALE],
  ['churchListStale', MARK_CHURCH_LIST_STALE, CLEAR_CHURCH_LIST_STALE],
  [
    'organizationListStale',
    MARK_ORGANIZATION_LIST_STALE,
    CLEAR_ORGANIZATION_LIST_STALE,
  ],
  ['membersListStale', MARK_MEMBERS_LIST_STALE, CLEAR_MEMBERS_LIST_STALE],
  ['chapelListStale', MARK_CHAPEL_LIST_STALE, CLEAR_CHAPEL_LIST_STALE],
  ['newsListStale', MARK_NEWS_LIST_STALE, CLEAR_NEWS_LIST_STALE],
  ['festivalsListStale', MARK_FESTIVALS_LIST_STALE, CLEAR_FESTIVALS_LIST_STALE],
  [
    'advertisementListStale',
    MARK_ADVERTISEMENT_LIST_STALE,
    CLEAR_ADVERTISEMENT_LIST_STALE,
  ],
  ['occasionListStale', MARK_OCCASION_LIST_STALE, CLEAR_OCCASION_LIST_STALE],
  [
    'liveStreamingListStale',
    MARK_LIVE_STREAMING_LIST_STALE,
    CLEAR_LIVE_STREAMING_LIST_STALE,
  ],
  [
    'incomePdfLinkListStale',
    MARK_INCOME_PDF_LINK_LIST_STALE,
    CLEAR_INCOME_PDF_LINK_LIST_STALE,
  ],
  ['eventsListStale', MARK_EVENTS_LIST_STALE, CLEAR_EVENTS_LIST_STALE],
  ['quotesListStale', MARK_QUOTES_LIST_STALE, CLEAR_QUOTES_LIST_STALE],
  ['positionListStale', MARK_POSITION_LIST_STALE, CLEAR_POSITION_LIST_STALE],
];

const pendingPublish = (state = initState, action) => {
  switch (action.type) {
    case ENQUEUE_PUBLISH_JOB:
      return {
        ...state,
        jobs: [
          {
            ...action.payload,
            status: 'pending',
            phase: 'queued',
            percent: 0,
            error: null,
          },
          ...state.jobs,
        ],
      };
    case UPDATE_PUBLISH_JOB_PROGRESS: {
      const { id, percent, phase, status } = action.payload;
      return {
        ...state,
        jobs: state.jobs.map((job) =>
          job.id === id
            ? {
                ...job,
                ...(typeof percent === 'number' ? { percent } : {}),
                ...(phase ? { phase } : {}),
                ...(status ? { status } : {}),
              }
            : job,
        ),
      };
    }
    case REMOVE_PUBLISH_JOB:
      return {
        ...state,
        jobs: state.jobs.filter((job) => job.id !== action.payload),
      };
    default: {
      let nextState = state;
      stalePairs.forEach(([flagKey, markType, clearType]) => {
        if (action.type === markType) {
          nextState = { ...nextState, [flagKey]: true };
        }
        if (action.type === clearType) {
          nextState = { ...nextState, [flagKey]: false };
        }
      });
      return nextState;
    }
  }
};

export default pendingPublish;
